<div class="stick-top">
  <mat-toolbar><mat-icon>device_hub</mat-icon> Mount Points</mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/mountPoints/0">
      <mat-icon aria-label="Create a new Mount Point">add</mat-icon>
      Create a new Mount Point
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
    <tr>
      <th *ngIf="auth.isCompanyAdmin()" style="width: 75px;">
        <div class="vbox">
          Company
          <micro-company-select [(companyId)]="filter.companyId" ></micro-company-select>
        </div>
      </th>
      <th><div class="vbox">Mount Point<input [(ngModel)]="filter.name"></div></th>
      <th><div class="vbox">OS Type<input [(ngModel)]="filter.osTypeName"></div></th>
      <th><div class="vbox">Purpose<input [(ngModel)]="filter.purpose"></div></th>
      <th><div class="vbox">Status<input [(ngModel)]="filter.statusName"></div></th>
      <th><div class="vbox">Type<input [(ngModel)]="filter.typeName"></div></th>
      <th><div class="vbox">File System<input [(ngModel)]="filter.fileSystemName"></div></th>
      <th><div class="vbox">Min Size<input [(ngModel)]="filter.minSize"></div></th>
      <th><div class="vbox">Max Size<input [(ngModel)]="filter.maxSize"></div></th>
      <th><div class="vbox">Separate Disk<input [(ngModel)]="filter.seperateDisk"></div></th>
      <th><div class="vbox">Description<input [(ngModel)]="filter.description"></div></th>
      <th><div class="vbox">Active<input [(ngModel)]="filter.active"></div></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td *ngIf="auth.isCompanyAdmin()"><micro-company-lookup [companyId]="element.companyId"></micro-company-lookup></td>
      <td><a routerLink="/mountPoints/{{element.id}}">{{element.name}}</a></td>
      <td>{{osTypeNames.get(element.osTypeId) || "-"}}</td>
      <td>{{element.purpose}}</td>
      <td>{{statusNames.get(element.statusId) || "-"}}</td>
      <td>{{typeNames.get(element.typeId) || "-"}}</td>
      <td>{{fileSystemNames.get(element.fileSystemId) || "-"}}</td>
      <td>{{element.minSize}}</td>
      <td>{{element.maxSize}}</td>
      <td>{{element.seperateDisk}}</td>
      <td>{{element.description}}</td>
      <td>{{element.active}}</td>
    </tr>
    <tr *ngIf="dataSource.data?.length === 0"><td colspan="100"><em>No results found</em></td></tr>
    </tbody>
    <tfoot><tr><td colspan="100">
      <mat-paginator #paginator (page)="reload()"></mat-paginator>
    </td></tr></tfoot>
  </table>
</div>
